$(document).on('click', '.js_form__submit', function () {
    let formWrapper = $(this).closest('.js_form')
    formTools.formVerify(formWrapper)
})

$(document).on('focus', '.js_form__input', function () {
    formTools.clearError($(this).closest('.js_form__item'))
})

$(document).on('blur', '.js_form__input', function () {
    let wrapper = $(this).closest('.js_form__item')
    if (wrapper.hasClass('require') && $(this).val() == '') {
        formTools.addError(wrapper, 'empty')
        return
    }

    if (wrapper.hasClass('require') && $(this).val().length < 2) {
        formTools.addError(wrapper, 'too_short')
        return
    }

    if (wrapper.hasClass('validate') && $(this).val() != '') {
        if (!formTools.elemVerify(wrapper)) {
            formTools.addError(wrapper, 'incorrect')
            return
        }
    }
})

$(document).on('change', 'select.js_form__input', function () {
    formTools.clearError($(this).closest('.js_form__item'))
})

$(document).on('change', '.js_form__files', function(e) {
    let label = $(this).closest('.form__label')
    let wrapper = $(this).closest('.js_form__item')
    let trash = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M18 6V16.2C18 17.8802 18 18.7202 17.673 19.362C17.3854 19.9265 16.9265 20.3854 16.362 20.673C15.7202 21 14.8802 21 13.2 21H10.8C9.11984 21 8.27976 21 7.63803 20.673C7.07354 20.3854 6.6146 19.9265 6.32698 19.362C6 18.7202 6 17.8802 6 16.2V6M14 10V17M10 10V17" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>'
    let file = $(`<span type="button" class="form__files-item">${e.target.files[0].name}<span/>`)
    wrapper.find('.form__files-item').remove()
    label.after(file)
    formTools.clearError($(this).closest('.js_form__item'))
})

$(document).on('change', '.js_form__checkbox', function() {
    let wrapper = $(this).closest('.js_form__item')
    if (wrapper.hasClass('require')) {
        if (!$(this).prop('checked')) {
            formTools.addError(wrapper)
        } else {
            formTools.clearError(wrapper)
        }
    } 
})

const formTools = {
    formVerify: function (form) {
        let isVerify = true
        this.clearAllErrors(form)
        $('.js_form__login-error').removeAttr('style')
        form.find('.js_form__item').each((i, el) => {
            if ($(el).find('.js_form__input').length) {
                let inputVal = $(el).find('.js_form__input').val().trim()
                if ($(el).hasClass('require')) {
                    if (inputVal == '') {
                        this.addError($(el), 'empty')
                        isVerify = false
                    }
                }
                if ($(el).hasClass('validate') && inputVal != '') {
                    if (!this.elemVerify($(el))) {
                        this.addError($(el), 'incorrect')
                        isVerify = false
                    }
                }
            }
            if ($(el).find('.js_form__files').length) {
                if ($(el).hasClass('require') && !$(el).find('.js_form__files')[0].files.length) {
                    this.addError($(el), 'empty')
                    isVerify = false
                }
            }
            if ($(el).find('.js_form__checkbox').length) {
                if ($(el).hasClass('require') && !$(el).find('.js_form__checkbox').prop('checked') ) {
                    this.addError($(el))
                    isVerify = false
                }
            }
        })
        if (isVerify == true) {
            this.sendForm(form)
        }
    },
    elemVerify: function (el) {
        let regex
        let inputVal = el.find('.js_form__input').val().trim()
        switch (el.find('.js_form__input').attr('name')) {
            case 'email':
                regex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/
                break;
            case 'old_password':
            case 'new_password':
            case 'password':
                regex = /^(?=.*[A-Z])(?=.*\d).{8,}$/
                break;
        }
        return el.find('.js_form__input').attr('name') == 'phone' ? inputVal.replace(/\D/g, '').length == 12 : regex.test(inputVal)
    },
    clearError: function (el) {
        el.find('.js_form__error').removeAttr('style')
        el.find('.js_form__input').removeClass('error')
        el.find('.form__select').removeClass('error')
        el.find('.js_form__checkbox').removeClass('error')
    },
    clearAllErrors: function (form) {
        form.find('.js_form__error').removeAttr('style')
        form.find('.js_form__input').removeClass('error')
        form.find('.form__select').removeClass('error')
        form.find('.js_form__checkbox').removeClass('error')
    },
    clearFields: function (form) {
        form.find('.js_form__item.clear .js_form__input').val('')
        formTools.clearAllErrors(form)
    },
    addError: function (el, type) {
        el.find('.js_form__input').addClass('error')
        el.find('.form__select').addClass('error')
        el.find('.js_form__checkbox').addClass('error')
        switch (type) {
            case 'empty':
                el.find('.js_form__error_empty').css('display', 'block')
                break;
            case 'incorrect':
                el.find('.js_form__error_incorrect').css('display', 'block')
                break;
            case 'email_used':
                el.find('.js_form__error_used').css('display', 'block')
                break;
            case 'pass_incorrect':
                el.find('.js_form__error_pass_incorrect').css('display', 'block');
                break;
            case 'too_short':
                if (el.find('[name=first_name]').length > 0) {
                    el.find('.js_form__error_fn_too_short').css('display', 'block')
                }
                if (el.find('[name=last_name]').length > 0) {
                    el.find('.js_form__error_ln_too_short').css('display', 'block')
                }
                break;
            case 'email_not_found':
                $(el).find('.js_form__error_email_not_found').css('display', 'block')
                break;
            default:
                break;
        }
    },
    popUpSave: function (save) {
        let popUp = $(`<div class="global__popup global__popup_save">${save ? save : langs.popUpSave}</div>`)
        $('body').append(popUp)
        setTimeout(function () {
            popUp.remove()
        }, 3200)
    },
    popUpError: function (error) {
        let popUp = $(`<div class="global__popup global__popup_error">${error ? error : langs.popUpError}</div>`)
        $('body').append(popUp)
        setTimeout(function () {
            popUp.remove()
        }, 3200)
    },
    formLoad: function(form) {
        let loader = $('<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#fff"><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity="1" stroke="#ffffff" cx="18" cy="18" r="18"/><path stroke="#E8542F" d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/></path></g></g></svg>')
        let loaderWrapper = $('<div class="form__loader"></div>')
        loader.appendTo(loaderWrapper)
        loaderWrapper.appendTo(form)
    },
    formSuccess: function(form) {
        console.log(form)
        form.find('.form__loader').remove()
        form.find('.js_form__submit-success').addClass('active')
    },
    formError: function(form) {
        form.find('.form__loader').remove()
        form.find('.js_form__submit-error').addClass('active')
    }, 
    sendForm: function (form) {
        let dataForm = { data: {} }
        let dataFiles = new FormData()
        form.find('.js_form__files').each((i, el) => {
            dataFiles.append( $(el).attr('name') ,el.files[0])
        })
        form.find('.js_form__submit-error').removeClass('active')
        if (form.find('.js_form__files').length) {
            dataForm.data.files = dataFiles
        }
        form.find('.js_form__input').each((i, el) => {
            if ($(el).val().trim() != '') {
                if ($(el).attr('name') == 'phone') {
                    dataForm.data[$(el).attr('name')] = $(el).val().trim().replace(/\D/g, '')
                } else {
                    dataForm.data[$(el).attr('name')] = $(el).val().trim()
                }
            }
        })
        form.find('.js_form__checkbox').each((i, el) => {
            if ($(el).attr('name') != 'agreement') {
                if ($(el).prop('checked')) {
                    dataForm.data[$(el).attr('name')] = 1
                } else {
                    dataForm.data[$(el).attr('name')] = 0
                }
            }
        })
        switch (form.attr('data-form')) {
            case 'feedback':
                formTools.formLoad(form)
                $.post(requests.postSend, dataForm.data, function(data) {
                    if (data.status == 'ok') {
                        formTools.formSuccess(form)
                    } else {
                        formTools.formError(form)
                    }
                }).fail(function () {
                    formTools.formError(form)
                })
            break;
        }
    },
}

window.formTools = formTools